/* eslint-disable react/prop-types */
const LineGradient = ({ width = 'w-full' }) => <div className={`h-0.5 ${width} bg-gradient-rainblue`} />;

export default LineGradient;
